import { UNSPECIFIED_LABEL } from '../config/labels';
import { Statuses } from '../types/status';

export const MAX_ADDITIONAL_SURVEYORS = 5;

export const UNASSIGNED_SURVEYOR_OPTION = {
  nameFirst: 'Not',
  nameLast: 'Assigned',
  uid: UNSPECIFIED_LABEL,
  email: UNSPECIFIED_LABEL,
};

export function getSurveyorOptionName(surveyor: {
  nameFirst: string;
  nameLast: string;
}) {
  return `${surveyor.nameFirst} ${surveyor.nameLast}`;
}

export function getMainSurveyorIdOrUnassigned(mainSurveyorId?: string | null) {
  return mainSurveyorId || UNSPECIFIED_LABEL;
}

export function isUnassignedSurveyorId(surveyorId?: string | null) {
  return !surveyorId || surveyorId === UNSPECIFIED_LABEL;
}

export function normaliseAdditionalSurveyorIds(
  additionalSurveyorIds: Array<string | null | undefined> = [],
  mainSurveyorId?: string | null,
) {
  const normalisedMainSurveyorId = `${mainSurveyorId || ''}`.trim();

  if (isUnassignedSurveyorId(normalisedMainSurveyorId)) {
    return [];
  }

  return Array.from(
    new Set(
      additionalSurveyorIds
        .map((uid) => `${uid || ''}`.trim())
        .filter(
          (uid) =>
            uid &&
            uid !== UNSPECIFIED_LABEL &&
            uid !== normalisedMainSurveyorId,
        ),
    ),
  ).slice(0, MAX_ADDITIONAL_SURVEYORS);
}

export function normaliseSurveyorAssignmentChange({
  mainSurveyorId,
  additionalSurveyorIds,
}: {
  mainSurveyorId?: string | null;
  additionalSurveyorIds?: Array<string | null | undefined>;
}) {
  const normalisedMainSurveyorId = getMainSurveyorIdOrUnassigned(
    `${mainSurveyorId || ''}`.trim(),
  );

  return {
    mainSurveyorId: normalisedMainSurveyorId,
    additionalSurveyorIds: normaliseAdditionalSurveyorIds(
      additionalSurveyorIds,
      normalisedMainSurveyorId,
    ),
  };
}

export function getSurveyStatusForAssignment({
  mainSurveyorId,
  surveyorIds,
}: {
  mainSurveyorId?: string | null;
  surveyorIds?: string[];
}) {
  return isUnassignedSurveyorId(mainSurveyorId) || !(surveyorIds || []).length
    ? Statuses.UNASSIGNED
    : Statuses.ISSUED;
}
